import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <div class="col-md-12 footer">
      <small>Web App realizzata da Claudio Vittoriani 
      © Copyright 2021 <a href="https://mytools.synology.me:500/covid19/">mysynology</a>
      <br>
      I dati sono aggiornati alle ore 17.00 e presi dal repository ufficiale della protezione civile by <i style="color: red" class="fa fa-heart" aria-hidden="true"></i> <a href="https://github.com/pcm-dpc/COVID-19">  Git  </a>
      </small>
    </div>
  `,
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
